// extracted by css-extract-rspack-plugin
module.exports =  {"emptyStateBottomPadding":"AmendmentsCard__emptyStateBottomPadding___ajVFX","root":"AmendmentsCard__root___CTbeR"};